interface ToastOptions {
  title: string
  description?: string
  variant?: 'default' | 'destructive'
}

export function useToast() {
  const toast = (options: ToastOptions) => {
    // Simple console implementation for now
    // In production, this would integrate with a proper toast system
    console.log(`[Toast] ${options.title}${options.description ? ': ' + options.description : ''}`)
  }

  return { toast }
}